import script from "./GCompaniaFuncionesAdicionales.vue?vue&type=script&setup=true&lang=js"
export * from "./GCompaniaFuncionesAdicionales.vue?vue&type=script&setup=true&lang=js"

import "./GCompaniaFuncionesAdicionales.vue?vue&type=style&index=0&id=e0b015bc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0b015bc"]])

export default __exports__